import CartDiscountCheckingQueries from './CartDiscountCheckingQueries'

const cartDiscounts = {
  cartDiscounts: {
    ...CartDiscountCheckingQueries,
  }
}

export default cartDiscounts